import axios from "axios";
import {getServerEndPoint} from "../liveshows/webEndPoint";

/**
 * Toggles fullscreen mode for a given element.
 * If no element is provided, it tries to toggle fullscreen for the entire document.
 * @param {HTMLElement} [element=document.documentElement] The element to toggle fullscreen for. Defaults to document.documentElement.
 */
async function toggleFullscreen( element = document.documentElement) {
    const fullscreenElement = document.fullscreenElement ||
        document.mozFullScreenElement || // Firefox
        document.webkitFullscreenElement || // Chrome, Safari, Edge
        document.msFullscreenElement; // IE/Edge (older)

    if (fullscreenElement) {
        // Currently in fullscreen, so exit
        if (document.exitFullscreen) {
            await document?.exitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        }
    } else {
        // Not in fullscreen, so enter
        if (element.requestFullscreen) {
            try {
                await element?.requestFullscreen();
            }
            catch (ex) {
                console.error(ex)
            }
        } else if (element.mozRequestFullScreen) {
            element.mozRequestFullScreen();
        } else if (element.webkitRequestFullscreen) {
            element.webkitRequestFullscreen();
        } else if (element.msRequestFullscreen) {
            element.msRequestFullscreen();
        } else {
            console.warn("Fullscreen API is not supported by this browser.");
        }
    }
}
const setFullscreen = async  () => {
    const toggleButton = document.getElementById('toggleFullscreenButton');
    const targetElement = document.getElementById('fullscreen-container'); // Or document.documentElement for full page
    if (toggleButton && targetElement) {
        toggleButton.addEventListener('click', () => {
            toggleFullscreen(targetElement);
        });
    }
}

const trimText = (text, maxLength) => {
    if(text){
        if(text.length> maxLength){
            return text.substring(0, maxLength) + " ..."
        }
        else {
            return  text
        }
    }
}

const getLabelMinute = (date) =>{
    if(date.getMinutes() > 9){
        return date.getHours() + ":" + date.getMinutes()
    }
    return  date.getHours() + ":0" + date.getMinutes()
}

const getIsoChannelLocalToken = async (channelId, userId, channelToken, channelName) => {

    //Canal plus Ghana problem
    let channelServerToken = channelToken
    if(channelToken.includes(".live-gtm.afr.canal-overseas.com")){
        channelServerToken = channelServerToken.replace(".live-gtm.afr.canal-overseas.com", "-live-canalplus.akamaized.net")
    }
    const channelConfigs = {
        "channelId": channelId,
        "userId": userId,
        "token": channelServerToken,
        "channelName": channelName
    }
    const serverPostUrl = getServerEndPoint() + "channel/user/iso/channel"
    const  configs = {
        headers : {
            "contentType":"application/json"
        }
    }
    return await axios.post(serverPostUrl, channelConfigs, configs);
}
const getChannelLocalToken = async (channelId, userId, channelToken, channelName) => {

    //Canal plus Ghana problem
    let channelServerToken = channelToken
    if(channelToken.includes(".live-gtm.afr.canal-overseas.com")){
        channelServerToken = channelServerToken.replace(".live-gtm.afr.canal-overseas.com", "-live-canalplus.akamaized.net")
    }
    const channelConfigs = {
        "channelId": channelId,
        "userId": userId,
        "token": channelServerToken,
        "channelName": channelName
    }
    const serverPostUrl = getServerEndPoint() + "channel/user/channel"
    const  configs = {
         headers : {
             "contentType":"application/json"
         }
    }
    return await axios.post(serverPostUrl, channelConfigs, configs);
}


const getChannelLocalTokenAdswitched = async (channelId, userId, channelServerToken, channelName, mpdLink) => {

    const channelConfigs = {
        "channelId": channelId,
        "userId": userId,
        "token": mpdLink,
        "tokenAdswitched" :channelServerToken,
        "channelName": channelName
    }
    const serverPostUrl = getServerEndPoint() + "channel/user/channel-adswitched"
    const  configs = {
        headers : {
            "contentType":"application/json"
        }
    }
    return await axios.post(serverPostUrl, channelConfigs, configs);
}
const getLogoURL = (imageResolution) => {
    return  imageResolution.replace("{resolutionXY}","130x100")
}


const getImageUrl = (basePictureUrl, resolution, dpr = 1) => {
    if (!basePictureUrl) return '';

    const resolutionString = `${resolution.width}x${resolution.height}`;
    const qualityString =  'filters:quality(80)';

    // Adjust resolution for 2x if dpr is 2
    const finalResolutionString = dpr === 2
        ? `${resolution.width * 2}x${resolution.height * 2}`
        : resolutionString;

    return basePictureUrl.replace("{resolutionXY}", finalResolutionString + `/${qualityString}`);
};

function isWindowEdge() {
    return (
        typeof window.chrome !== 'undefined' &&
        typeof window.chrome.runtime !== 'undefined' && // Chrome has this
        navigator.userAgent.includes('Edg') &&
        navigator.userAgent.includes('Windows/')
    );
}

function isPlayStationBrowser() {
    const userAgent = navigator.userAgent.toLowerCase();
    // Common User Agent patterns for PlayStation consoles
    // Note: These can change with system updates, and some might be generic.
    // It's best to look for multiple keywords for better accuracy.
    return userAgent.includes("playstation") || userAgent.includes("ps4") || userAgent.includes("ps5");

}
function isChromiumEdgeMac() {
    return (
        typeof window.chrome !== 'undefined' &&
        typeof window.chrome.runtime !== 'undefined' && // Chrome has this
        navigator.userAgent.includes('Edg') &&
        navigator.userAgent.includes('Mac/')
    );
}
function getLiveMacSafari() {
    const userAgent = navigator.userAgent;
     return (userAgent.includes('Safari') && !userAgent.includes('Chrome'))
}

function isSafari() {
    return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
export {
    setFullscreen,
    getLabelMinute,
    getChannelLocalToken,
    getLogoURL,
    isWindowEdge,
    isChromiumEdgeMac,
    isPlayStationBrowser,
    isSafari,
    getLiveMacSafari,
    getImageUrl,
    trimText,
    getIsoChannelLocalToken
    ,getChannelLocalTokenAdswitched
}